import h from 'react-hyperscript';

import AuthService from '../../lib/AuthService';

import AppContainer from '../../containers/AppContainer';
import Login from '../../components/Login/Login';

export default ({ component, ...rest }) =>
  AuthService.isAuthenticated()
    ? h(AppContainer, {
        ...rest,
        className: 'authenticated',
      })
    : h(Login);



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/index.js